// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"c11aba02","64":"381ea6e0","369":"bdd85318","419":"0c1a5560","496":"da2e92b5","563":"00e3be64","812":"36b43576","906":"eed677cf","942":"b4795f7e"}[chunkId] + ".chunk.js";
};